type Params = {
  [id: string]: boolean | number | string
}

function buildSearchParams(params: Params): string {
  return Object.keys(params)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&')
}

export function addSearchParamsToUrl(baseUrl: string, params: Params): string {
  if (!params) {
    return baseUrl
  }

  const character = !baseUrl.includes('?') ? '?' : '&'
  return `${baseUrl}${character}${buildSearchParams(params)}`
}
